import { fetchPostCreditCardCrossSellOfferContinue } from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const useMarkContinue = () => {
    const stateKey = useStateKey();

    return useMutation({
        mutationFn: () =>
            fetchPostCreditCardCrossSellOfferContinue({ stateKey })
    });
};
